import { combineReducers } from "redux";
import mapReducer from "../components/map/ducks";
import filtersReducers from "../components/filters/ducks";
import dataReducer from "../components/data/ducks";

export default combineReducers({
  filters: filtersReducers,
  data: dataReducer,
  map: mapReducer
});



// WEBPACK FOOTER //
// ./src/store/reducers.js